import { render, staticRenderFns } from "./UserMergeDialog.vue?vue&type=template&id=5c04f8b6"
import script from "./UserMergeDialog.vue?vue&type=script&lang=js"
export * from "./UserMergeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports